import * as React from 'react'
import styled from 'styled-components'
import { COMMON, CommonProps } from 'global'
import { path } from './Paths'
import { Loader } from './Loader'

interface IIconProps extends CommonProps {
  name: keyof typeof path | 'loader'
  viewBox?: string
  size?: string
  fill?: string
  transform?: string
}

interface ISVGProps extends Partial<IIconProps> {}

const SVG: React.FunctionComponent<ISVGProps> = styled.svg<ISVGProps>`
  ${COMMON}
  height: ${({ size }) => size};
`

export const Icon = ({
  name,
  size = '24px',
  viewBox = '24',
  fill = 'currentColor',
  transform = '',
  ...props
}: IIconProps) => {
  const paths = ([] as string[]).concat(path[name])
  return (
    <SVG size={size} viewBox={`0 0 ${viewBox} ${viewBox}`} {...props}>
      {name === 'loader' ? (
        <Loader />
      ) : (
        paths.map((p, i) => (
          <path key={`icon-svg-${i}`} d={p} fill={fill} transform={transform} />
        ))
      )}
    </SVG>
  )
}
